import * as React from 'react';
import Highlighter from 'react-highlight-words';
import styled from 'styled-components';
import { Box, Text, theme } from '@frameio/vapor';

type MemberEmailProps = {
  email: string;
  searchWords?: string[];
  truncate?: boolean;
};

export const MemberEmail = ({
  email = '',
  searchWords = [''],
  truncate,
  ...rest
}: MemberEmailProps & Partial<React.ComponentProps<typeof Text>>) => {
  if (!email || typeof email !== 'string') {
    return null;
  }

  const [emailUser, emailDomain] = email.split(/(?=@)/);

  const highlighterProps = {
    autoEscape: true,
    highlightStyle: {
      backgroundColor: theme.colors.background.interactive.highlight,
      color: theme.colors.text.body,
    },
    searchWords,
  };

  return (
    <>
      {truncate && emailUser && emailDomain ? (
        <StyledDiv aria-label={email} role="text">
          <Box aria-hidden="true" flexShrink="0" maxWidth="75%">
            <Text truncate={true} {...rest}>
              <Highlighter textToHighlight={emailUser} {...highlighterProps} />
            </Text>
          </Box>
          <Box aria-hidden="true" minWidth="25%">
            <Text truncate={true} {...rest}>
              <Highlighter
                textToHighlight={emailDomain}
                {...highlighterProps}
              />
            </Text>
          </Box>
        </StyledDiv>
      ) : (
        <Text {...rest}>
          <Highlighter textToHighlight={email} {...highlighterProps} />
        </Text>
      )}
    </>
  );
};

const StyledDiv = styled.div`
  display: inline-flex;
  max-width: 100%;
  padding-right: ${theme.spaces[2]};
`;
